export const getTooltipster = () => import('tooltipster/dist/js/tooltipster.bundle.min')
